import { configureStore } from '@reduxjs/toolkit';

import authenticationReducer from './authentication/authenticationReducer';
import clientsReducer from './clients/clientsReducer';
import childrenReducer from './children/childrenReducer';
import documenationReducer from './documentation/documentationReducer';
import settingsReducer from './settings/settingsReducer';
import notificationReducer from './common/notification/notificationReducer';

import type { Client } from './common/types/client';
import type { Child } from './common/types/child';
import type { DecryptedItem } from './common/types/items';
import type { Documentation } from './common/types/documentation';
import type { Notification } from './common/types/notification';
import { Transfer } from './common/types/transfer';
import { Setting } from './common/types/settings';
import transfersReducer from './transfer/transfersReducer';

type AuthenticationState = {
  isInitialized: boolean;
  isLoading: boolean;
  isInitLoading: boolean;
  isLoginLoading: boolean;
  isAuthenticated: boolean;
  salt: string | null;
  errorMessage: string | undefined | null;
};

type ClientsState = {
  clients: DecryptedItem<Client>[];
  currentClient: DecryptedItem<Client> | null;
  status: 'idle' | 'loading' | null;
  errorMessage: string | undefined | null;
};

type ChildrenState = {
  children: DecryptedItem<Child>[];
  currentChild: DecryptedItem<Child> | null;
  status: 'idle' | 'loading' | null;
  errorMessage: string | undefined | null;
};

type TransfersState = {
  transfers: DecryptedItem<Transfer>[];
  currentTransfer: DecryptedItem<Transfer> | null;
  status: 'idle' | 'loading' | null;
  errorMessage: string | undefined | null;
};

type DocumentationState = {
  documentation: Documentation[];
  status: 'idle' | 'loading' | null;
  errorMessage: string | undefined | null;
};

type NotificationState = {
  notification: Notification[];
};

type SettingsState = {
  advisors: Setting[];
  groups: Setting[];
  status: 'idle' | 'loading' | null;
  errorMessage: string | undefined | null;
};

type Store = {
  authentication: AuthenticationState;
  clients: ClientsState;
  children: ChildrenState;
  transfers: TransfersState;
  documentation: DocumentationState;
  settings: SettingsState;
  notificaiton: NotificationState;
};

const store = configureStore<Store>({
  reducer: {
    authentication: authenticationReducer,
    clients: clientsReducer,
    children: childrenReducer,
    transfers: transfersReducer,
    documentation: documenationReducer,
    settings: settingsReducer,
    notificaiton: notificationReducer,
  },
});

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export type {
  RootState,
  AppDispatch,
  Store,
  AuthenticationState,
  ClientsState,
  ChildrenState,
  TransfersState,
  DocumentationState,
  SettingsState,
  NotificationState,
};

export default store;
